import { useContainer } from '@bydesign-ui/hooks';
import { getElementPosition } from '@bydesign-ui/hooks';
import { useCallback } from 'react';
import { useRegion } from './useRegion';
export function useRegionClick(elem) {
  var region = useRegion();
  var elemGetter = useContainer(elem);
  return useCallback(function (e) {
    var el = elemGetter();

    if (el == null) {
      return;
    }

    var offset = getElementPosition(el);
    var x = e.clientX - offset.left;
    var y = e.clientY - offset.top;
    var point = region.getPointByOffset({
      x: x,
      y: y
    });

    if (point.getDragging()) {
      point.setDragging(false);
    }

    point.updateRealOffset(point.getOffset(), {
      x: x,
      y: y
    });
  }, []);
}